/**
 * Utility function to highlight search keyword terms in text.
 * Supports multi-term keywords separated by half-width or full-width spaces (Japanese).
 *
 * @param {string} text - The source text to highlight.
 * @param {string} keyword - The search keyword containing one or more terms.
 * @returns {string} Safe HTML string with matched terms wrapped in <span class="highlight">.
 */
function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function highlightText(text, keyword) {
  if (!text || typeof text !== 'string') return text || '';
  if (!keyword || typeof keyword !== 'string') return text;

  const terms = keyword
    .trim()
    .split(/[\s\u3000]+/)
    .filter(Boolean)
    .map(escapeRegExp);

  if (terms.length === 0) return text;

  // Sort longest terms first so substrings don't break longer matches
  terms.sort((a, b) => b.length - a.length);

  const regex = new RegExp(`(${terms.join('|')})`, 'gi');
  return text.replace(regex, '<span class="highlight">$1</span>');
}

export default {
  highlightText,
};
